
import React, { useState } from 'react'

const LongText = ({ content,limit, showTooltip}) => {
  const [showAll, setShowAll] = useState(false);

  const showMore = () => setShowAll(true);
  const showLess = () => setShowAll(false);

  if (content.length <= limit) {
    // there is nothing more to show
    return <div>{content}</div>
  }
  if (showAll) {
    // We show the extended text and a link to reduce it
    return <div> 
      {content} 
      <a href='#' onClick={showLess}>Read less</a> 
    </div>
  }
  // In the final case, we show a text with ellipsis and a `Read more` button
  const toShow = content ? content.substring(0, limit) + "..." : "";
  return <div title={showTooltip ? content: ''}> 
    {toShow} 
    {
      !showTooltip && 
      <a href="#" onClick={showMore}>Read more</a>
      }
  </div>
}

export default LongText;